class e {
  static HORZ = new e("horz");
  static VERT = new e("vert");
  static flip(t) {
    return t === e.HORZ ? e.VERT : e.HORZ;
  }
  /** @internal */
  _name;
  /** @internal */
  constructor(t) {
    this._name = t;
  }
  equlas(t) {
    return this._name === t._name;
  }
  getName() {
    return this._name;
  }
  toString() {
    return this._name;
  }
}
export {
  e as Orientation
};
//# sourceMappingURL=Orientation.js.map
